import React from 'react';
import cx from 'classnames';
import { compose, defaultProps } from 'recompose';
import styles from './styles.css';

export type Props = {
  size?: 'small' | 'medium' | 'large';
  style?: any;
  children: any | string;
  className?: string;
  id?: string;
  bottom?: number;
  top?: number;
};

export type OwnProps = Props & {
  size: 'small' | 'medium' | 'large';
};

export const Title = compose<OwnProps, Props>(defaultProps({ size: 'medium' }))(
  ({ children, className, size, style, bottom, top, ...rest }) => (
    <h4
      {...rest}
      className={cx(styles.root, styles[size], className)}
      style={{ marginBottom: bottom, marginTop: top, ...style }}
    >
      {children}
    </h4>
  )
);
